import { render } from "./FormClient.vue?vue&type=template&id=36ab0be9&scoped=true"
import script from "./FormClient.vue?vue&type=script&lang=js"
export * from "./FormClient.vue?vue&type=script&lang=js"

import "./FormClient.vue?vue&type=style&index=0&id=36ab0be9&scoped=true&lang=scss"

import exportComponent from "D:\\source\\Mobaxe.Docs.App\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-36ab0be9"],['__file',"src/views/FormClient.vue"]])
/* hot reload */
if (module.hot) {
  __exports__.__hmrId = "36ab0be9"
  const api = __VUE_HMR_RUNTIME__
  module.hot.accept()
  if (!api.createRecord('36ab0be9', __exports__)) {
    console.log('reload')
    api.reload('36ab0be9', __exports__)
  }
  
  module.hot.accept("./FormClient.vue?vue&type=template&id=36ab0be9&scoped=true", () => {
    console.log('re-render')
    api.rerender('36ab0be9', render)
  })

}


export default __exports__